import { logger } from './logger';

export async function validatePDF(file: File): Promise<boolean> {
  try {
    // Check file type
    if (!file.type.includes('pdf')) {
      throw new Error(`Invalid file type: ${file.type}`);
    }
    
    // Check file size (10MB limit)
    const MAX_SIZE = 10 * 1024 * 1024;
    if (file.size > MAX_SIZE) {
      throw new Error(`File too large: ${(file.size / 1024 / 1024).toFixed(2)}MB`);
    }
    
    return true;
  } catch (error) {
    logger.error('PDF validation failed', { fileName: file.name });
    throw error;
  }
}